import { render } from "./MainApp.vue?vue&type=template&id=1ca160ac"
import script from "./MainApp.vue?vue&type=script&lang=js"
export * from "./MainApp.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webik150-website-vue/webik150-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__